// Collection-page quick-add. Ticket 001-006.
//
// One delegated document listener serves every card in the grid — the
// snippet renders once per product, so per-card init would mean one
// listener per card.
(function () {
  var GENERIC_ERROR = 'Could not add to cart. Please try again.';

  // What is already in the cart, by variant id, so the stock ceiling counts
  // it. Populated from /cart.js and refreshed after every add.
  var inCart = {};

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function card(el) {
    return el.closest('[data-quick-add]');
  }

  function readCart(cart) {
    inCart = {};
    (cart.items || []).forEach(function (item) {
      inCart[item.id] = item.quantity;
    });
    return cart;
  }

  // The price shown is Debut's own product-price element, a sibling of the
  // quick-add block inside the card.
  function priceEl(root) {
    var productCard = root.closest('.product-card');
    return productCard && productCard.querySelector('dl[data-price]');
  }

  function syncPrice(root) {
    var select = root.querySelector('[data-quick-add-variant]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var dl = priceEl(root);
    if (!dl) return;

    var price = parseInt(option.dataset.variantPrice, 10);
    var compareAt = parseInt(option.dataset.variantCompareAt, 10);
    var onSale = compareAt > price;

    // Debut's contract: the regular slot carries the compare-at price and
    // the theme strikes it through, but only while the list has
    // price--on-sale — which is also what reveals the sale slot. Written to
    // every match, as the theme's own script does.
    dl.classList.toggle('price--on-sale', onSale);

    var regular = dl.querySelectorAll('[data-regular-price]');
    for (var i = 0; i < regular.length; i += 1) {
      regular[i].textContent = money(onSale ? compareAt : price);
    }
    var sale = dl.querySelector('[data-sale-price]');
    if (sale) sale.textContent = money(price);
  }

  function step(root, delta) {
    var qty = root.querySelector('[data-quick-add-qty]');
    var next = (parseInt(qty.value, 10) || 1) + delta;
    qty.value = Math.max(1, next);
  }

  function showError(root, message) {
    root.querySelector('[data-quick-add-error]').textContent = message;
  }

  function clearError(root) {
    root.querySelector('[data-quick-add-error]').textContent = '';
  }

  // Confirms on the button itself rather than a toast, so the feedback
  // lands where the customer is already looking. The label is restored to a
  // constant, not to whatever it read at call time — a second add inside the
  // window would otherwise capture "Added" and never revert.
  function confirmAdded(root) {
    var label = root.querySelector('[data-quick-add-submit-label]');
    var submit = root.querySelector('[data-quick-add-submit]');
    clearTimeout(root.quickAddTimer);
    label.textContent = 'Added';
    submit.setAttribute('data-added', '');
    root.quickAddTimer = setTimeout(function () {
      label.textContent = 'Add to cart';
      submit.removeAttribute('data-added');
    }, 1500);
  }

  // #CartCount only renders when the header believes the cart is non-empty
  // (see sections/header.liquid), so a quick-add into a previously empty
  // cart has nothing here to update — build it, matching the markup the
  // section renders server-side.
  function ensureHeaderCount() {
    var count = document.getElementById('CartCount');
    if (count) return count;

    var cartLink = document.querySelector('.site-header__cart');
    if (!cartLink) return null;

    count = document.createElement('div');
    count.id = 'CartCount';
    count.className = 'site-header__cart-count';
    count.appendChild(document.createElement('span'));

    var fallback = document.createElement('span');
    fallback.className = 'icon__fallback-text medium-up--hide';
    count.appendChild(fallback);

    cartLink.appendChild(count);
    return count;
  }

  // Same absence-on-empty-cart gap as #CartCount above, so it gets the same
  // build-on-demand treatment, matching header.liquid's #CartSubtotal markup.
  function ensureHeaderSubtotal() {
    var subtotal = document.getElementById('CartSubtotal');
    if (subtotal) return subtotal;

    var cartLink = document.querySelector('.site-header__cart');
    if (!cartLink) return null;

    subtotal = document.createElement('span');
    subtotal.id = 'CartSubtotal';
    subtotal.className = 'site-header__cart-subtotal';
    // header.liquid renders it as the link's first child, ahead of the
    // icon — match that order so a first-add build doesn't jump it to the
    // opposite side.
    cartLink.insertBefore(subtotal, cartLink.firstChild);
    return subtotal;
  }

  function updateHeaderCount(cart) {
    var count = ensureHeaderCount();
    if (!count) return;
    var spans = count.querySelectorAll('span');
    if (spans[0]) spans[0].textContent = cart.item_count;
    if (spans[1]) spans[1].textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
  }

  function updateHeaderSubtotal(cart) {
    var subtotal = ensureHeaderSubtotal();
    if (!subtotal) return;
    subtotal.textContent = money(cart.total_price);
  }

  // What Shopify will still sell of the selected variant, or null for
  // unlimited. The attribute is absent whenever stock is untracked or the
  // variant is set to continue selling.
  function availableLimit(form) {
    var select = form.querySelector('[data-quick-add-variant]');
    var source = select
      ? select.options[select.selectedIndex]
      : form.querySelector('[name="id"]');
    var raw = source && source.getAttribute('data-variant-available');
    if (raw === null || raw === undefined) return null;

    var stock = parseInt(raw, 10);
    if (isNaN(stock)) return null;
    // An oversold variant reports negative stock, and the cart already holds
    // part of the allowance.
    return Math.max(0, stock - (inCart[source.value] || 0));
  }

  function submitForm(form) {
    var root = card(form);
    if (form.dataset.busy === '1') return;
    clearError(root);

    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = root.querySelector('[data-quick-add-qty]');
    var quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    var submit = root.querySelector('[data-quick-add-submit]');

    // Shopify accepts an over-stock add and only corrects it at checkout, so
    // the ceiling is enforced here or the customer finds out far too late.
    var limit = availableLimit(form);
    if (limit !== null && quantity > limit) {
      showError(root, limit === 0 ? 'None available.' : 'Only ' + limit + ' available.');
      return;
    }

    form.dataset.busy = '1';
    submit.disabled = true;

    function done() {
      delete form.dataset.busy;
      submit.disabled = false;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantInput.value, quantity: quantity }),
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () { throw new Error(GENERIC_ERROR); })
          .then(function (data) {
            if (!res.ok) {
              // Only Shopify's own wording is fit to show the customer; a
              // parse or network failure is not.
              var refusal = new Error(data.description || data.message || GENERIC_ERROR);
              refusal.fromShopify = true;
              throw refusal;
            }
            return data;
          });
      })
      .then(function () {
        confirmAdded(root);
        return fetch('/cart.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        cart = readCart(cart);
        updateHeaderCount(cart);
        updateHeaderSubtotal(cart);
      })
      .then(done, function (err) {
        showError(root, err.fromShopify ? err.message : GENERIC_ERROR);
        done();
      });
  }

  function init() {
    if (document.body.dataset.quickAddReady === '1') return;
    document.body.dataset.quickAddReady = '1';

    // The card's server-rendered price is the product's lowest, which need
    // not be the variant that comes preselected.
    document.querySelectorAll('[data-quick-add]').forEach(syncPrice);

    if (typeof fetch === 'function') {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(readCart)
        .catch(function () { /* no prior quantities; the ceiling still holds */ });
    }

    document.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-quick-add-decrement]');
      var inc = e.target.closest('[data-quick-add-increment]');
      if (dec) step(card(dec), -1);
      if (inc) step(card(inc), 1);
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-quick-add-variant]')) syncPrice(card(e.target));
    });

    document.addEventListener('submit', function (e) {
      if (e.target.matches('[data-quick-add-form]')) {
        e.preventDefault();
        submitForm(e.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
